import axios, { AxiosResponse } from 'axios';
import * as models from 'models/index';
import * as constants from 'util/constants';
import * as helpers from 'util/helpers';

class Api {
  storage = this.initializeStorage();
  defaults: models.api.IDefaults = { wid: constants.DEFAULT_WID, lang: constants.DEFAULT_LANG };

  constructor() {
    this.getQSPs();
  }

  fetchGeo(): Promise<models.api.IGeoData> {
    return axios
      .get(constants.API_GEO)
      .then((res: AxiosResponse) => res.data)
      .catch(err => {
        throw new Error(err);
      });
  }

  private getQSPs(): void {
    window.location.search
      .slice(1)
      .split('&')
      .forEach(item => {
        const [key, value = ''] = item.split('=');

        this.storage.qsps[key] = value;
      });
  }
  /**
   * initializeStorage
   */
  private initializeStorage(): models.api.IStorage {
    const storage = Object.create(null);
    storage.cms = Object.create(null);
    storage.qsps = Object.create(null);

    return storage;
  }

  postToVoteApi(payload: any, versionId: string, apiUrl = constants.CONNECT_ENDPOINT, token?: string): any {
    const usePTMUProxy = payload.action_type === constants.ACTION_TYPES.VOTE && token && token !== '';
    const qsp = helpers.convertToQspString(payload);
    const hash = helpers.createHash(qsp, `${versionId}${constants.VERSION_CHECK}`);
    const encodedHash = helpers.fixedEncodeUriComponent(hash);
    const url = `${apiUrl}?${qsp}`;
    let data;

    if ( usePTMUProxy ) {
      data = {};
      data['Authorization'] = encodedHash;
      data['token'] = token;
    } else {
      data = `Authorization=${encodedHash}`;
    }

    const options = {
      headers: { 'Content-Type': `application/${ usePTMUProxy ? 'json' : 'x-www-form-urlencoded'}; charset=UTF-8` }
    };

    return axios.post(url, data, options)
      .then((res: AxiosResponse) => res.data)
      .catch(err => console.error('Voteapi call failed:', err.message));
  }
}

export default new Api();
